import { PettyCashFundStatus } from '../../models/petty-cash-fund/petty-cash-fund';

/** Fund status → translated label (#5785). */
export function fundStatusLabel(status: PettyCashFundStatus, t: (key: string, fallback: string) => string): string {
  switch (status) {
    case PettyCashFundStatus.Draft:
      return t('PettyCashFund_Status_Draft', 'Draft');
    case PettyCashFundStatus.ReadyForFunding:
      return t('PettyCashFund_Status_ReadyForFunding', 'Ready for funding');
    case PettyCashFundStatus.Active:
      return t('PettyCashFund_Status_Active', 'Active');
    case PettyCashFundStatus.Closed:
      return t('PettyCashFund_Status_Closed', 'Closed');
    default:
      return '';
  }
}

/** Fund status → p-tag severity. */
export function fundStatusSeverity(status: PettyCashFundStatus): 'success' | 'secondary' | 'warn' | 'info' {
  switch (status) {
    case PettyCashFundStatus.ReadyForFunding:
      return 'info';
    case PettyCashFundStatus.Active:
      return 'success';
    case PettyCashFundStatus.Draft:
      return 'warn';
    default:
      return 'secondary';
  }
}
